import _extends from "@babel/runtime/helpers/extends";
import React, { Fragment, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DomainVerify(props) {
  var {
    href
  } = props || {};
  var [hide, setHide] = useState(false);
  useEffect(() => {
    if (window && window.location) {
      var isVisiable = false;
      var protocol = window.location.protocol;
      var hostname = href.replace(/^(https?):\/\//, '');
      if (window.location.href.replace(/^(https?):\/\//, '').indexOf(hostname) > -1) {
        isVisiable = true;
      }
      if (/^(https?):\/\//.test(href) && !new RegExp("^" + protocol).test(href)) {
        isVisiable = false;
      }
      setHide(isVisiable);
    }
  }, [href]);
  if (!hide) return /*#__PURE__*/_jsx(Fragment, {});
  return /*#__PURE__*/_jsx(Fragment, {
    children: React.Children.toArray(props.children).map(child => {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      return /*#__PURE__*/React.cloneElement(child, _extends({}, child.props));
    })
  });
}